import { Alert } from '@mui/material';
import axios, { AxiosError } from 'axios';

interface ErrorAlertProps {
  error: unknown;
}

export function ErrorAlert({ error }: ErrorAlertProps) {
  const getMessageFromError = (err: unknown) => {
    if (axios.isAxiosError<{ message: string } | string>(err)) {
      return getMessageFromAxiosError(err);
    } else if (error instanceof Error) {
      return error.message;
    }

    return 'Something went wrong';
  };

  const getMessageFromAxiosError = (err: AxiosError<{ message: string } | string>) => {
    if (err.response) {
      return err.response.data ? parseDataFromResponse(err.response.data) : err.response.statusText;
    }

    return err.message;
  };

  const parseDataFromResponse = (data: { message: string } | string) => {
    if (typeof data === 'string') {
      return data;
    } else if (data.message) {
      return data.message;
    }

    return JSON.stringify(data);
  };

  const message = getMessageFromError(error);

  return <Alert color="error">{message}</Alert>;
}
